import React from 'react';

export const useTableSearch = ({ searchValue, retrieve }) => {
	const [filteredData, setFilteredData] = React.useState([]);
	const [currentData, setCurrentData] = React.useState([]);
	const [searchIndex, setSearchIndex] = React.useState([]);

	const crawl = React.useCallback((data: any, allValues?: Array<string>) => {
		if (!allValues) {
			allValues = [];
		}

		for (const key in data) {
			if (typeof data[key] === 'object') {
				crawl(data[key], allValues);
			} else {
				allValues.push(data[key] + ' ');
			}
		}
		return allValues;
	}, []);

	const fetchData = React.useCallback(async () => {
		const { data }: { data: Array<any> } = await retrieve();
		if (data.length > 0) {
			setCurrentData(data);
			setFilteredData(data);
			const searchInd = data.map((item) => {
				const allValues = crawl(item);
				return { allValues: allValues.toString() };
			});
			setSearchIndex(searchInd);
		}
	}, [crawl, retrieve]);

	React.useEffect(() => {
		fetchData();
	}, [fetchData]);

	React.useEffect(() => {
		if (searchValue) {
			const data = searchIndex.map((item, index) => {
				if (
					item.allValues.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0
				) {
					return currentData[index];
				}
				return null;
			});

			setFilteredData(
				data.filter((item) => {
					if (item) {
						return true;
					}
					return false;
				}),
			);
		} else {
			setFilteredData(currentData);
		}
	}, [searchValue, currentData, searchIndex]);

	return { filteredData };
};
